import React, { useEffect, useState } from "react";
import AddGroup from "../AddLabTest/AddGroup/AddGroup.js";
import "../AddLabTest/AddGroup/groupdetail.css";
import { FaTrash, FaEdit, FaPlus, FaChevronDown, FaChevronUp } from "react-icons/fa";
import axios from "axios";
import { APIURL, TZ } from "../../../Global.js";
import { useAlert } from 'react-alert';
import AddClinic from "./AddClinic.js";
import AddPolicy from "./AddPolicy.js";
import Confirmation from "./Confirmation.js";

const Grouping = () => {
    const [addGroup, setAddGroup] = useState(false);
    const [add, setAdd] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [refresh1, setRefresh1] = useState(false)
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [isloading, setIsLoading] = useState(false)
    const [groups, setGroups] = useState(null)
    const [groupHospitals, setGroupHospitals] = useState([])
    const [filteredGroups, setFilteredGroups] = useState([])
    const [expandedSection, setExpandedSection] = useState({
        clinics: true,
        features: true
    });
    const [remove, setRemove] = useState({
        type: '',
        itemId: ''
    });
    const alert = useAlert();

    useEffect(() => {
        const fetchGroups = async () => {
            setIsLoading(true);
            try {
                const tokenString = sessionStorage.getItem("usertoken");
                const str = tokenString?.replace(/["]+/g, "");

                const response = await axios.get(`${APIURL}/api/v1/staff/hospital-group/`, {
                    headers: {
                        Authorization: "Token " + str,
                        "Content-Type": "application/json",
                    },
                });

                if (response.data.status === "success") {
                    setGroups(response.data.groups || []);

                    if (selectedGroup) {
                        const updatedGroup = response.data.groups.find(g => g.id === selectedGroup.id);
                        setSelectedGroup(updatedGroup || null);
                        if (updatedGroup) {
                            await fetchGroupHospitals(updatedGroup.id);
                        }
                    }
                } else {
                    alert.error('Error occurred, try again');
                }
            } catch (err) {
                console.error("Error fetching groups:", err);
                alert.error('Failed to fetch groups');
            } finally {
                setIsLoading(false);
            }
        };

        const fetchGroupHospitals = async (groupId) => {
            try {
                const tokenString = sessionStorage.getItem("usertoken");
                const str = tokenString?.replace(/["]+/g, "");

                const response = await axios.get(`${APIURL}/api/v1/staff/hospital-group/`, {
                    headers: {
                        Authorization: "Token " + str,
                        "Content-Type": "application/json",
                    },
                    params: {
                        group_id: groupId
                    }
                });

                if (response.data.status === "success") {
                    setSelectedGroup(response.data.groups[0])
                    setGroupHospitals(response.data.hospitals || []);
                }
            } catch (err) {
                console.error("Error fetching group hospitals:", err);
                setGroupHospitals([]);
            }
        };

        fetchGroups();
    }, [refresh, alert]);

    const handleGroupClick = async (group) => {
        try {
            const tokenString = sessionStorage.getItem("usertoken");
            const str = tokenString?.replace(/["]+/g, "");

            const response = await axios.get(`${APIURL}/api/v1/staff/hospital-group/`, {
                headers: {
                    Authorization: "Token " + str,
                    "Content-Type": "application/json",
                },
                params: {
                    group_id: group.id
                }
            });

            if (response.data.status === "success") {
                setSelectedGroup(response.data.groups[0])
                setGroupHospitals(response.data.hospitals || []);
            }
        } catch (err) {
            console.error("Error fetching group hospitals:", err);
            setGroupHospitals([]);
        }
    };

    useEffect(() => {
        if (selectedGroup) {
            handleGroupClick(selectedGroup);
        }
    }, [refresh1]);

    useEffect(() => {
        if (groups) {
            const filtered = groups.filter(group =>
                group.group_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredGroups(filtered);
        }
    }, [groups, searchTerm]);

    const toggleSection = (section) => {
        setExpandedSection(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const handleDeleteGroup = async (groupId) => {
        const tokenString = sessionStorage.getItem('usertoken');
        if (!tokenString) {
            alert.error("User not authenticated. Please log in.");
            return;
        }

        const token = tokenString.replace(/"/g, '').trim();

        try {
            const response = await axios.delete(
                `${APIURL}/api/v1/staff/hospital-group/?id=${groupId}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                }
            );

            if (response.status === 200 && response.data.status === 'success') {
                setRefresh(prev => !prev);
                alert.success("Group deleted successfully");

                if (selectedGroup?.id === groupId) {
                    setSelectedGroup(null);
                }
            } else {
                alert.error(response.data.message || "Failed to delete group.");
            }
        } catch (error) {
            console.error("Error deleting group:", error);
            alert.error(error.response?.data?.message || "Failed to delete group");
        }
    };

    const handleAddItems = (type) => {
        setAdd(type)
    };

    const handleRemoveItem = (type, itemId) => {
        setRemove({
            type: type,
            itemId: itemId
        });
        setShowConfirmation(true)
    };

    return (
        <div className="group-show-container">
            {isloading && <div className="loading-overlay">Loading...</div>}

            <div className="group-header">
                <h2>Clinic Groups</h2>
                <button
                    className="primary-btn"
                    onClick={() => {
                        setSelectedGroup(null);
                        setEditMode(false);
                        setAddGroup(true);
                    }}
                >
                    <FaPlus /> Add Group
                </button>
            </div>

            <div className="group-layout">
                <div className="group-list-container">
                    <div className="search-filter">
                        <input
                            type="text"
                            placeholder="Search groups..."
                            className="search-input"
                            style={{ height: "30px", lineHeight: "30px" }}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <div className="group-items">
                        {filteredGroups?.map(group => (
                            <div
                                key={group.id}
                                className={`group-card ${selectedGroup?.id === group.id ? 'active' : ''}`}
                                onClick={() => {
                                    handleGroupClick(group);
                                }}
                            >
                                <div className="group-card-header">
                                    <h4 style={{ textTransform: 'capitalize' }}>{group.group_name}</h4>
                                    <div className="group-actions">
                                        <FaTrash
                                            className="action-icon delete"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleRemoveItem('group', group.id);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="group-details-container">
                    {selectedGroup ? (
                        <>
                            <div className="details-header">
                                <h3 style={{ textTransform: 'capitalize' }}>{selectedGroup.group_name}</h3>
                            </div>

                            <div className="details-sections">
                                <div className="details-section">
                                    <div
                                        className="section-header clickable"
                                        onClick={() => toggleSection('clinics')}
                                    >
                                        <h4>
                                            Clinics
                                            <span className="count-badge">
                                                {groupHospitals?.length || 0}
                                            </span>
                                        </h4>
                                        <div className="section-actions">
                                            <button
                                                className="secondary-btn small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleAddItems('clinic');
                                                }}
                                            >
                                                <FaPlus /> Add Clinic
                                            </button>
                                            {expandedSection.clinics ? <FaChevronUp /> : <FaChevronDown />}
                                        </div>
                                    </div>

                                    {expandedSection.clinics && (
                                        groupHospitals?.length > 0 ? (
                                            <ul className="items-list">
                                                {groupHospitals.map((clinic) => (
                                                    <li key={clinic.id}>
                                                        <div className="item-info">
                                                            <span className="item-name">
                                                                {clinic.name}
                                                            </span>
                                                        </div>
                                                        <FaTrash
                                                            className="list-action-icon"
                                                            onClick={() => handleRemoveItem('clinic', clinic.id)}
                                                        />
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="empty-message">No clinics added to this group</p>
                                        )
                                    )}
                                </div>

                                <div className="details-section">
                                    <div
                                        className="section-header clickable"
                                        onClick={() => toggleSection('features')}
                                    >
                                        <h4>
                                            Features
                                            <span className="count-badge">
                                                {selectedGroup.sharable_policy?.length || 0}
                                            </span>
                                        </h4>
                                        <div className="section-actions">
                                            <button
                                                className="secondary-btn small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleAddItems('feature');
                                                }}
                                            >
                                                <FaPlus /> Add Feature
                                            </button>
                                            {expandedSection.features ? <FaChevronUp /> : <FaChevronDown />}
                                        </div>
                                    </div>
                                    {expandedSection.features && (
                                        selectedGroup.sharable_policy?.length > 0 ? (
                                            <ul className="items-list">
                                                {selectedGroup.sharable_policy.map((policy, index) => (
                                                    <li key={index}>
                                                        <div className="item-info" style={{ textTransform: 'capitalize' }}>
                                                            {policy.replace(/_/g, ' ')}
                                                        </div>
                                                        <FaTrash
                                                            className="list-action-icon"
                                                            onClick={() => handleRemoveItem('policy', policy)}
                                                        />
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="empty-message">No policies added to this group</p>
                                        )
                                    )}
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="empty-state">
                            <h3>Select a group to view details</h3>
                            <p>Or create a new group to get started</p>
                        </div>
                    )}
                </div>
            </div>

            {addGroup && (
                <AddGroup
                    from='clinic'
                    groupData={editMode ? selectedGroup : null}
                    handleSuccess={() => {
                        setRefresh(!refresh);
                        setAddGroup(false);
                        setEditMode(false);
                    }}
                    onClose={() => {
                        setAddGroup(false);
                        setEditMode(false);
                    }}
                />
            )}
            {add === 'clinic' && (
                <AddClinic
                    hospitals={groupHospitals}
                    group={selectedGroup}
                    handleSuccess={() => {
                        setRefresh1(!refresh1)
                        setAdd(false);
                    }}
                    onClose={() => {
                        setAdd(false);
                    }}
                />
            )}
            {add === 'feature' && (
                <AddPolicy
                    group={selectedGroup}
                    handleSuccess={() => {
                        setRefresh1(!refresh1)
                        setAdd(false);
                    }}
                    onClose={() => {
                        setAdd(false);
                    }}
                />
            )}
            {showConfirmation && (
                <Confirmation
                    group={selectedGroup}
                    type={remove.type}
                    id={remove.itemId}
                    onCancel={() => setShowConfirmation(false)}
                    onSuccess={() => {
                        if (remove.type === 'group') {
                            setRefresh(!refresh);
                            setSelectedGroup(null);
                        } else {
                            setRefresh1(!refresh1);
                        }
                        setShowConfirmation(false);
                    }}
                />
            )}
        </div>
    );
};

export default Grouping;